import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import QuoteForm from './quoteForm'; 
import SEO, { buildLocalBusinessSchema } from './SEO';
import { business, services } from './siteData';
import {
  ContactPanel,
  QuoteContentGrid,
  QuoteHero,
  QuoteWrapper,
  SuccessCard,
} from './styled/quote.style';

const Quote = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleFormSubmit = () => {
    setSubmitted(true);
  };

  return (
    <QuoteWrapper>
      <SEO
        title="Request a Drywall Quote | KMK Drywall"
        description="Request a drywall quote from KMK Drywall for residential drywall, commercial drywall, drywall repair, finishing, steel framing, or ceiling tile grid in Springville, Buffalo, Erie County, and Western New York."
        path="/quote"
        schema={buildLocalBusinessSchema('/quote')}
      />
      <QuoteHero>
        <p>Request a quote</p>
        <h1>Tell KMK Drywall about your project.</h1>
        <span>
          Share the job location, what type of drywall or ceiling work you need,
          and the best way to reach you. KMK Drywall serves {business.serviceArea}.
        </span>
      </QuoteHero>
      {submitted ? (
        <SuccessCard>
          <h2>Thank you! Your quote request has been submitted.</h2>
          <p>
            KMK Drywall will review your project details and follow up. For urgent
            scheduling questions, call <a href={business.phoneHref}>{business.phoneDisplay}</a>.
          </p>
          <Link to="/">Return to Home</Link>
        </SuccessCard>
      ) : (
        <QuoteContentGrid>
          <QuoteForm onSubmit={handleFormSubmit} />
          <ContactPanel>
            <h2>Prefer to talk first?</h2>
            <p>
              Call or email KMK Drywall with your project location, timeline, and
              a few photos if they help explain the work.
            </p>
            <a href={business.phoneHref}>{business.phoneDisplay}</a>
            <a href={business.emailHref}>{business.email}</a>
            <h3>Common quote requests</h3>
            <ul>
              {services.map((service) => (
                <li key={service.title}>{service.title}</li>
              ))}
            </ul>
          </ContactPanel>
        </QuoteContentGrid>
      )}
    </QuoteWrapper>
  );
};

export default Quote;
